import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const PageTitle = ({ title, description, url }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <>
      <Helmet>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={`https://cricketliveupdate.netlify.app/${url}`} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": title,
            "url": `https://cricketliveupdate.netlify.app/${url}`,
            "author": {
              "@type": "Person",
              "name": "Live Cricket Score App"
            },
            "description": description,
            "publisher": {
              "@type": "Organization",
              "name": "Live Cricket Score App",
              "logo": {
                "@type": "ImageObject",
                "url": "https://cricketliveupdate.netlify.app/logo192.png"
              }
            }
          })}
        </script>
      </Helmet>
    </>
  );
};

export default PageTitle;
